// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__UJ_aa","topBottomGutter":"Layout_topBottomGutter__2Buk4"};